import { get } from "lodash";
import ApiCalls from "../../../config/paymentConfig/apiCalls";
import Headers from "../../../config/paymentConfig/headers";
import Utility from "../../../helpers/paymentHelpers/utility";
import {
  RESPONSE,
  common,
  DEFAULT_TXN_STATUS_TIME,
  UNIFIED_ACTION,
} from "../../../helpers/paymentHelpers/paymentConstants";
import Crypto from "crypto-js";
import {
  keyMapsAction,
  keyMapsMutation,
} from "../../../helpers/paymentHelpers/storeKeys";
// import ampUtility from "../../../helpers/paymentHelpers/amplitude/ampUtility";
import constant from "../../../helpers/paymentHelpers/constant";

export default {
  namespaced: true,
  state: {
    isCustomContinueProgressBarOpen: false,
    placeOrderButtonColorGray: true,
    isOtpScreenEnable: false,
    disableResendKey: true,
    binDiscountData: {},
    cardNumber: "",
    binDiscountResponse: {
      success: {},
      error: {},
    },
    PayUsingOtherPaymentModeTrue: false,
    savedCardCvv: {
      cardNum: "",
      cvv: "",
    },
    saveCardCvvModal: false,
    razorPayResponse: {},
    unifiedResponse: {},
    stopApiCall: false,
    cardCheckError: { status: "" },
    cardOtpErrorMsg: {
      displayMsg: "",
    },
    stopOtpPolling: false,
    otpTimeout: null,
    otpValue: "",
    maxCount: 45,
    disableResendKey: true,
    cardTimeInterval: () => {},
  },
  getters: {},
  mutations: {
    updateCardOtpErrorMsg(state, payload) {
      state.cardOtpErrorMsg.displayMsg = payload || "";
    },
    updateCardCheckError(state, payload) {
      state.cardCheckError = payload;
    },
    updateSaveCardCvvModal(state, payload) {
      state.saveCardCvvModal = payload;
    },
    updateSuccessBinResponse(state, payload) {
      state.binDiscountResponse.success = payload;
    },
    updatePayUsingOtherPaymentMode(state, payload) {
      state.PayUsingOtherPaymentModeTrue = payload;
    },
    updateErrorBinResponse(state, payload) {
      state.binDiscountResponse.error = payload;
    },
    updateDisableResendKey(state, payload) {
      state.disableResendKey = payload;
    },
    updateIsOtpScreenEnable(state, payload) {
      state.isOtpScreenEnable = payload;
      state.otpValue = "";
      if (!payload) {
        state.razorPayResponse = {};
        state.unifiedResponse = {};
      }
    },
    updatePlaceOrderButtonColorGray(state, payload) {
      state.placeOrderButtonColorGray = payload;
    },
    updateCustomContinueProgressBar(state, payload) {
      state.isCustomContinueProgressBarOpen = payload;
    },
    updateBinDiscountStatus(state, payload) {
      state.binDiscountData = payload || {};
    },
    updateCreditAndDebitCardNumber(state, payload) {
      state.cardNumber = payload;
    },
    updateSavedCardCvv(state, payload) {
      let { cardNum, cvv } = payload;
      state.savedCardCvv.cvv = cvv;
      state.savedCardCvv.cardNum = cardNum;
    },
    saveRazorpayResponse(state, payload) {
      state.razorPayResponse = payload;
    },
    updateStopApiCall(state, payload) {
      state.stopApiCall = payload;
    },
    saveUnifiedResponse(state, payload) {
      state.unifiedResponse = payload;
    },
    updateStopOtpPolling(state, payload) {
      state.stopOtpPolling = payload;
    },
    updateOtpValue(state, payload) {
      state.otpValue = payload;
    },
  },
  actions: {
    resendOtpTimerHandler({ state, dispatch }) {
      dispatch("clearResendOtpTimer"); // reset the interval before start resend timer again
      state.maxCount = 45;
      state.disableResendKey = true;
      state.cardTimeInterval = setInterval(() => {
        state.maxCount -= 1;
        if (state.maxCount === 0) {
          state.disableResendKey = false;
          clearInterval(state.cardTimeInterval);
        }
      }, 1000);
    },
    clearResendOtpTimer({ state }) {
      clearInterval(state.cardTimeInterval);
    },
    otpTimerWithModal({ commit, dispatch }) {
      commit(keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL, true, {
        root: true,
      });
      commit("updateIsOtpScreenEnable", true);
      document.body.classList.add("body-stop-scroll-mobile");
      dispatch("resendOtpTimerHandler");
    },
    counter({ commit, state, dispatch }, tillTime) {
      setTimeout(() => {
        commit("updateStopApiCall", true);
      }, tillTime * 1000);
    },
    paymentStatusOTP({ commit, rootState, state, dispatch }, payload) {
      try {
        const submitResp = state.razorPayResponse;
        let queryData = {
          order_transaction_id: submitResp.orderTransactionId,
          payment_tranx_id: submitResp.paymentTranxId,
        };
        let md5 = Crypto.algo.MD5.create();
        md5.update("oms_merchant_id_1" + constant.RAZOR_SALT_ID);
        let payId = JSON.stringify(queryData);
        const checksum = md5.finalize(payId).toString();
        const headersObj = {
          xTenantID: true,
          mid: true,
          checksum: checksum,
        };
        setTimeout(() => {
          ApiCalls.RAZORPAY_PAYMENT_STATUS({
            headers: Headers(headersObj),
            payload: queryData,
          })
            .then(function (res) {
              if (res?.data) {
                let response = res?.data;
                switch (response.status) {
                  case RESPONSE.WAIT:
                    const razorpayTxStatusTime = get(
                      rootState,
                      "Global.appConfig.config.razorpayTxStatusTime",
                      DEFAULT_TXN_STATUS_TIME
                    );
                    if (!state.stopApiCall) {
                      dispatch("paymentStatusOTP", {
                        delay: razorpayTxStatusTime.nextCallTime,
                      });
                    } else {
                      const content = {
                        bodyMsg: common.internalServerError,
                        headerMsg: common.ops,
                        rightCTAText: common.ok,
                      };
                      dispatch(keyMapsAction.OPEN_ERROR_MODAL, content, {
                        root: true,
                      });
                      commit("updateCustomContinueProgressBar", false);
                      commit("updateStopApiCall", false);
                    }
                    break;
                  case RESPONSE.SUCCESS: {
                    Utility.sendToThankYouScreen(submitResp.orderTransactionId);
                    commit("updateCustomContinueProgressBar", false);
                    commit("updateStopApiCall", false);
                    break;
                  }
                  case RESPONSE.FAILED: {
                    const errMsg =
                      (response &&
                        response.errors[0] &&
                        response.errors[0].displayMsg) ||
                      common.internalServerError;
                    const data = {
                      bodyMsg: errMsg,
                      headerMsg: common.ops,
                      rightCTAText: common.ok,
                    };
                    dispatch(keyMapsAction.OPEN_ERROR_MODAL, data, {
                      root: true,
                    });
                    commit("updateCustomContinueProgressBar", false);
                    commit("updateStopApiCall", false);
                    break;
                  }
                  default: {
                    const content = {
                      bodyMsg: common.internalServerError,
                      headerMsg: common.ops,
                      rightCTAText: common.ok,
                    };
                    dispatch(keyMapsAction.OPEN_ERROR_MODAL, content, {
                      root: true,
                    });
                    commit("updateCustomContinueProgressBar", false);
                    commit("updateStopApiCall", false);
                    break;
                  }
                }
              } else if (res?.errors) {
                const err = get(res, "errors[0]", "");
                const errData = {
                  bodyMsg: err.displayMsg || common.internalServerError,
                  headerMsg: err.header || common.ops,
                  rightCTAText: err.btnMsg || common.ok,
                };
                dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                  root: true,
                });
                commit("updateCustomContinueProgressBar", false);
                commit("updateStopApiCall", false);
              } else if (res?.error) {
                const errData = {
                  bodyMsg: res.message || common.internalServerError,
                  headerMsg: common.ops,
                  rightCTAText: common.ok,
                };
                dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                  root: true,
                });
                commit("updateCustomContinueProgressBar", false);
                commit("updateStopApiCall", false);
              }
            })
            .catch(function (error) {
              console.log("ERROR in Resend OTP.... 101", error);
              const err = get(error, "errors[0]", "");
              const errData = {
                bodyMsg: err.displayMsg || "Failed to Resend OTP",
                headerMsg: err.header || common.ops,
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
              commit("updateCustomContinueProgressBar", false);
            });
        }, 1000 * payload.delay);
      } catch (err) {
        console.error("ERROR IN validateOTP", err);
      }
    },
    submitOTP({ commit, rootState, state, dispatch }, payload) {
      try {
        commit("updateCustomContinueProgressBar", true);
        const headersObj = {
          xTenantID: true,
          mid: true,
        };
        let dataObj = {
          endPoint: payload.otpSubmitUrl,
          data: { otp: payload.code },
        };
        ApiCalls.SUBMIT_RAZORPAY_OTP({
          headers: Headers(headersObj),
          payload: dataObj,
        })
          .then(function (res) {
            if (res?.data) {
              let response = res?.data;
              switch (response.status) {
                case RESPONSE.WAIT:
                  const razorpayTxStatusTime = get(
                    rootState,
                    "Global.appConfig.config.razorpayTxStatusTime",
                    DEFAULT_TXN_STATUS_TIME
                  );
                  dispatch("counter", razorpayTxStatusTime.totalTime);
                  dispatch("paymentStatusOTP", {
                    delay: razorpayTxStatusTime.nextCallTime,
                  });
                  break;
                case RESPONSE.SUCCESS: {
                  commit(
                    keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL,
                    false,
                    { root: true }
                  );
                  commit("updateIsOtpScreenEnable", false);
                  dispatch("clearResendOtpTimer");
                  Utility.sendToThankYouScreen(response.orderTransactionId);
                  commit("updateCustomContinueProgressBar", false);
                  break;
                }
                case RESPONSE.FAILED: {
                  const errMsg =
                    (response &&
                      response.errors[0] &&
                      response.errors[0].displayMsg) ||
                    common.internalServerError;
                  const errData = {
                    bodyMsg: errMsg,
                    headerMsg: common.ops,
                    rightCTAText: common.ok,
                  };
                  dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                    root: true,
                  });
                  commit("updateCustomContinueProgressBar", false);

                  commit("updateCardOtpErrorMsg", errData.bodyMsg || "");
                  // ampUtility.impressionPayActionEventAmp({
                  //   eventAction: "otp_error",
                  //   errorMsg: errData?.message || "Invalid OTP",
                  //   paymentId: "CC",
                  //   Page_Name: "confirm_otp_add_card",
                  //   previousScreenname: "add_new_card"
                  // })
                  break;
                }
                default: {
                  const content = {
                    bodyMsg: common.internalServerError,
                    headerMsg: common.ops,
                    rightCTAText: common.ok,
                  };
                  dispatch(keyMapsAction.OPEN_ERROR_MODAL, content, {
                    root: true,
                  });
                  commit("updateCustomContinueProgressBar", false);
                  commit(
                    keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL,
                    false,
                    { root: true }
                  );
                  commit("updateIsOtpScreenEnable", false);
                  dispatch("clearResendOtpTimer");
                  commit("updateCardOtpErrorMsg", "");
                  break;
                }
              }
            } else if (res?.errors) {
              const err = get(res, "errors[0]", "");
              const errData = {
                bodyMsg: err.displayMsg || common.internalServerError,
                headerMsg: err.header || common.ops,
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
              commit("updateCustomContinueProgressBar", false);
              commit(
                keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL,
                false,
                { root: true }
              );
              commit("updateIsOtpScreenEnable", false);
              dispatch("clearResendOtpTimer");
              commit("updateCardOtpErrorMsg", "");
            } else if (res?.error) {
              const errData = {
                bodyMsg: res.message || common.internalServerError,
                headerMsg: common.ops,
                rightCTAText: common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
              commit("updateCustomContinueProgressBar", false);
              commit(
                keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL,
                false,
                { root: true }
              );
              commit("updateIsOtpScreenEnable", false);
              dispatch("clearResendOtpTimer");
              commit("updateCardOtpErrorMsg", "");
            }
          })
          .catch(function (error) {
            console.log("ERROR in Resend OTP.... 101", error);
            const err = get(error, "errors[0]", "");
            const errData = {
              bodyMsg: err.displayMsg || "Failed to Resend OTP",
              headerMsg: err.header || common.ops,
              rightCTAText: err.btnMsg || common.ok,
            };
            dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
            commit("updateCustomContinueProgressBar", false);
            commit(keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL, false, {
              root: true,
            });
            commit("updateIsOtpScreenEnable", false);
            dispatch("clearResendOtpTimer");
            commit("updateCardOtpErrorMsg", "");
          });
      } catch (err) {
        console.error("ERROR IN validateOTP", err);
        commit("updateCustomContinueProgressBar", false);
        commit(keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL, false, {
          root: true,
        });
        commit("updateIsOtpScreenEnable", false);
        dispatch("clearResendOtpTimer");
        commit("updateCardOtpErrorMsg", "");
      }
    },
    otpFlowPolling({ commit, state, dispatch, rootState }, payload) {
      console.log("OTP FLOW POLLING...", payload);
      const unifiedResponse = payload.unifiedPaymentResponse;
      const pollResponse = get(unifiedResponse, "nextActions.poll", {});
      const { duration = 600000, interval = 5000, url } = pollResponse;
      //call the polling and timer
      dispatch("otpPollCounter", { tillTime: duration });
      dispatch("otpPollStatus", {
        delay: interval,
        url,
        orderTransactionId: payload.orderTransactionId,
      });
    },
    otpPollCounter({ commit, state, dispatch }, payload) {
      let { tillTime } = payload;
      state.otpTimeout = setTimeout(() => {
        console.log("TIME out...");
        commit("updateStopOtpPolling", true);
        //timeout error
        const content = {
          bodyMsg: common.internalServerError || "Timeout Error",
          headerMsg: common.ops,
          rightCTAText: common.ok,
        };
        dispatch(keyMapsAction.OPEN_ERROR_MODAL, content, { root: true });
        commit(keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL, false, {
          root: true,
        });
        commit("updateIsOtpScreenEnable", false);
        dispatch("clearResendOtpTimer");
      }, tillTime);
    },
    otpPollStatus({ commit, rootState, state, dispatch }, payload) {
      try {
        console.log("GET OTP STAUS....", payload, state.stopOtpPolling);
        setTimeout(() => {
          ApiCalls.GET_COLLECT_UPI_STATUS_API({
            headers: Headers(),
            payload: {},
            url: payload.url,
          })
            .then(function (res) {
              if (res?.data) {
                let response = res?.data;
                console.log("RESPONSE....", res);
                switch (response.transactionStatus) {
                  case RESPONSE.INPROGRESS:
                    if (!state.stopOtpPolling) {
                      dispatch("otpPollStatus", payload);
                    }
                    break;
                  case RESPONSE.SUCCESS: {
                    Utility.sendToThankYouScreen(payload.orderTransactionId);
                    setTimeout(() => {
                      commit(
                        keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL,
                        false,
                        { root: true }
                      );
                      commit("updateIsOtpScreenEnable", false);
                      dispatch("clearResendOtpTimer");
                    }, 800);
                    break;
                  }
                  case RESPONSE.FAILED: {
                    console.log("FAILURE......", response);
                    const errMsg =
                      (response && response.displayMsg) ||
                      common.internalServerError;
                    const data = {
                      bodyMsg: errMsg,
                      headerMsg: common.ops,
                      rightCTAText: common.ok,
                    };
                    dispatch(keyMapsAction.OPEN_ERROR_MODAL, data, {
                      root: true,
                    });
                    // ampUtility.impressionPayActionEventAmp({
                    //   eventAction: "otp_polling_error",
                    //   errorMsg: errMsg,
                    //   paymentId: "CC",
                    //   Page_Name: "confirm_otp_add_card",
                    //   previousScreenname: "add_new_card"
                    // });
                    commit("updateCustomContinueProgressBar", false);
                    commit(
                      keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL,
                      false,
                      { root: true }
                    );
                    commit("updateIsOtpScreenEnable", false);
                    dispatch("clearResendOtpTimer");
                    commit("updateCardOtpErrorMsg", "");
                    break;
                  }
                  default: {
                    const content = {
                      bodyMsg: common.internalServerError,
                      headerMsg: common.ops,
                      rightCTAText: common.ok,
                    };
                    dispatch(keyMapsAction.OPEN_ERROR_MODAL, content, {
                      root: true,
                    });
                    break;
                  }
                }
              } else if (res?.errors) {
                const err = get(res, "errors[0]", "");
                const errData = {
                  bodyMsg: err.displayMsg || common.internalServerError,
                  headerMsg: err.header || common.ops,
                  rightCTAText: err.btnMsg || common.ok,
                };
                dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                  root: true,
                });
              } else if (res?.error) {
                const errData = {
                  bodyMsg: res.message || common.internalServerError,
                  headerMsg: common.ops,
                  rightCTAText: common.ok,
                };
                dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                  root: true,
                });
              }
            })
            .catch(function (error) {
              console.log("ERROR in collect UPI status.... 101", error);
              const err = get(error, "errors[0]", "");
              const errData = {
                bodyMsg: err.displayMsg || "Failed to get status",
                headerMsg: err.header || common.ops,
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
            });
        }, payload.delay);
      } catch (err) {
        console.error("ERROR IN collect UPI status", err);
      }
    },
    submitOTPHandler({ commit, rootState, state, dispatch }, payload) {
      try {
        commit("updateCustomContinueProgressBar", true);
        commit("updateStopOtpPolling", false);
        clearTimeout(state.otpTimeout);
        let dataObj = {
          endPoint: payload.otpSubmitUrl,
          data: { otp: payload.code },
          // data: {otp: 'payload.code'}
        };
        ApiCalls.SUBMIT_UNIFIED_OTP({
          headers: Headers(),
          payload: dataObj,
        })
          .then(function (res) {
            if (res?.data) {
              let response = res?.data;
              switch (response.transactionStatus) {
                case RESPONSE.INPROGRESS:
                  console.log(
                    "OTP SUBMIT INPROGRESS.....",
                    response,
                    state.unifiedResponse
                  );
                  const unifiedActions = response.nextActions || {};
                  switch (unifiedActions.action) {
                    case UNIFIED_ACTION.POLL:
                      console.log("OTP SUBMIT POLL CASE....", unifiedActions);
                      dispatch("otpFlowPolling", state.unifiedResponse);
                      break;
                    case UNIFIED_ACTION.OTPRETRY:
                      console.log(
                        "OTP SUBMIT OTP RETRY CASE....",
                        unifiedActions
                      );
                      commit(
                        "updateCardOtpErrorMsg",
                        response.displayMsg || "Please enter correct OTP"
                      );
                      commit("updateCustomContinueProgressBar", false);
                      const paymentObj =
                        rootState.PaymentSubmit?.paymentModeTemp || {};
                      const {
                        cardScheme = "",
                        issuerDisplayName = "",
                        paymentId = "",
                        label = "",
                        paymentMode = "",
                      } = paymentObj;
                      console.log("paymentObj....", paymentObj);
                      // ampUtility.paymentStatusEventAmp({
                      //   eventAction: "Failed",
                      //   eventLabel: label || "",
                      //   paymentMode: paymentMode,
                      //   paymentId: paymentId || "",
                      //   bankName: issuerDisplayName.length > 0 ? issuerDisplayName : "",
                      //   cardType: cardScheme.length > 0 ? cardScheme : "",
                      //   errormsg: response.displayMsg || 'Please enter correct OTP',
                      //   Page_Name: "payment_lp",
                      //   previousScreenname: "cart"
                      // });
                      break;
                    default:
                      commit("updateCustomContinueProgressBar", false);
                      break;
                  }
                  break;
                case RESPONSE.SUCCESS: {
                  console.log("SUCCESS....", response, payload);
                  Utility.sendToThankYouScreen(payload.orderTransactionId);
                  commit(
                    keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL,
                    false,
                    { root: true }
                  );
                  commit("updateIsOtpScreenEnable", false);
                  dispatch("clearResendOtpTimer");
                  commit("updateCustomContinueProgressBar", false);
                  break;
                }
                case RESPONSE.FAILED: {
                  console.log("FAILED STATE....", response);
                  const errMsg =
                    (response && response.displayMsg) ||
                    common.internalServerError;
                  const errData = {
                    bodyMsg: errMsg,
                    headerMsg: common.ops,
                    rightCTAText: common.ok,
                  };
                  dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                    root: true,
                  });
                  commit("updateCustomContinueProgressBar", false);

                  // commit("updateCardOtpErrorMsg", errData.bodyMsg || "")   //field specific error msg
                  // ampUtility.impressionPayActionEventAmp({
                  //   eventAction: "otp_error",
                  //   errorMsg: errData?.message || "Invalid OTP",
                  //   paymentId: "CC",
                  //   Page_Name: "confirm_otp_add_card",
                  //   previousScreenname: "add_new_card"
                  // })
                  break;
                }
                default: {
                  console.log("DEFAULT CASE...");
                  const content = {
                    bodyMsg: common.internalServerError,
                    headerMsg: common.ops,
                    rightCTAText: common.ok,
                  };
                  dispatch(keyMapsAction.OPEN_ERROR_MODAL, content, {
                    root: true,
                  });
                  commit("updateCustomContinueProgressBar", false);
                  commit(
                    keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL,
                    false,
                    { root: true }
                  );
                  commit("updateIsOtpScreenEnable", false);
                  dispatch("clearResendOtpTimer");
                  commit("updateCardOtpErrorMsg", "");
                  break;
                }
              }
            } else if (res?.errors) {
              const err = get(res, "errors[0]", "");
              const errData = {
                bodyMsg:
                  err.displayMsg || err.message || common.internalServerError,
                headerMsg: err.header || common.ops,
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
              commit("updateCustomContinueProgressBar", false);
              // commit(keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL, false, {root: true});
              // commit("updateIsOtpScreenEnable", false);
              // dispatch("clearResendOtpTimer");
            } else if (res?.error) {
              const errData = {
                bodyMsg: res.message || common.internalServerError,
                headerMsg: common.ops,
                rightCTAText: common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
              commit("updateCustomContinueProgressBar", false);
              commit(
                keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL,
                false,
                { root: true }
              );
              commit("updateIsOtpScreenEnable", false);
              dispatch("clearResendOtpTimer");
              commit("updateCardOtpErrorMsg", "");
            }
          })
          .catch(function (error) {
            console.log("ERROR in Resend OTP.... 101", error);
            const err = get(error, "errors[0]", "");
            const errData = {
              bodyMsg: err.displayMsg || "Failed to Resend OTP",
              headerMsg: err.header || common.ops,
              rightCTAText: err.btnMsg || common.ok,
            };
            dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
            commit("updateCustomContinueProgressBar", false);
            commit(keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL, false, {
              root: true,
            });
            commit("updateIsOtpScreenEnable", false);
            dispatch("clearResendOtpTimer");
            commit("updateCardOtpErrorMsg", "");
          });
      } catch (err) {
        console.error("ERROR IN validateOTP", err);
        commit("updateCustomContinueProgressBar", false);
        commit(keyMapsMutation.UDPATE_ADD_CREDIT_DEBIT_CARD_MODAL, false, {
          root: true,
        });
        commit("updateIsOtpScreenEnable", false);
        dispatch("clearResendOtpTimer");
        commit("updateCardOtpErrorMsg", "");
      }
    },
    resendOTP({ commit, state, dispatch }, payload) {
      try {
        commit("updateCustomContinueProgressBar", true);
        const headersObj = {
          xTenantID: true,
          mid: true,
          checksum: payload.checksum,
        };
        let dataObj = {
          endPoint: payload.otpResendUrl,
        };
        ApiCalls.RESEND_RAZORPAY_OTP({
          headers: Headers(headersObj),
          payload: dataObj,
        })
          .then(function (res) {
            if (res?.data) {
              let response = res?.data;
              switch (response.status) {
                case RESPONSE.SUCCESS:
                  break;
                case RESPONSE.FAILED:
                  const errMsg =
                    response &&
                    response.errors[0] &&
                    response.errors[0].displayMsg;
                  const errData = {
                    bodyMsg: errMsg || common.internalServerError,
                    headerMsg: common.ops,
                    rightCTAText: common.ok,
                  };
                  dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                    root: true,
                  });
                  break;
                default:
                  const content = {
                    bodyMsg: common.internalServerError,
                    headerMsg: common.ops,
                    rightCTAText: common.ok,
                  };
                  dispatch(keyMapsAction.OPEN_ERROR_MODAL, content, {
                    root: true,
                  });
                  break;
              }
            } else if (res?.errors) {
              const err = get(res, "errors[0]", "");
              const errData = {
                bodyMsg: err.displayMsg || common.internalServerError,
                headerMsg: err.header || common.ops,
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
            } else if (res?.error) {
              const errData = {
                bodyMsg: res.message || common.internalServerError,
                headerMsg: common.ops,
                rightCTAText: common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
            }
          })
          .catch(function (error) {
            console.log("ERROR in Resend OTP.... 101", error);
            const err = get(error, "errors[0]", "");
            const errData = {
              bodyMsg: err.displayMsg || "Failed to Resend OTP",
              headerMsg: err.header || common.ops,
              rightCTAText: err.btnMsg || common.ok,
            };
            dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
          });
      } catch (err) {
        console.error("Resend OTP ERROR", err);
      } finally {
        commit("updateCustomContinueProgressBar", false);
      }
    },
    resendOTPHandler({ commit, state, dispatch }, payload) {
      try {
        commit("updateCustomContinueProgressBar", true);
        let dataObj = {
          endPoint: payload.otpResendUrl,
        };
        ApiCalls.RESEND_UNIFIED_OTP({
          headers: Headers(),
          payload: dataObj,
        })
          .then(function (res) {
            if (res?.data) {
              let response = res?.data;
              switch (response.eventStatus) {
                case RESPONSE.SUCCESS:
                  break;
                case RESPONSE.FAILED:
                  const errMsg =
                    (response && response.displayMsg) ||
                    common.internalServerError;
                  const errData = {
                    bodyMsg: errMsg || common.internalServerError,
                    headerMsg: common.ops,
                    rightCTAText: common.ok,
                  };
                  dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                    root: true,
                  });
                  break;
                default:
                  const content = {
                    bodyMsg: common.internalServerError,
                    headerMsg: common.ops,
                    rightCTAText: common.ok,
                  };
                  dispatch(keyMapsAction.OPEN_ERROR_MODAL, content, {
                    root: true,
                  });
                  break;
              }
            } else if (res?.errors) {
              const err = get(res, "errors[0]", "");
              const errData = {
                bodyMsg:
                  err.displayMsg || err.message || common.internalServerError,
                headerMsg: err.header || common.ops,
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
            } else if (res?.error) {
              const errData = {
                bodyMsg: res.message || common.internalServerError,
                headerMsg: common.ops,
                rightCTAText: common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
            }
          })
          .catch(function (error) {
            console.log("ERROR in Resend OTP.... 101", error);
            const err = get(error, "errors[0]", "");
            const errData = {
              bodyMsg: err.displayMsg || "Failed to Resend OTP",
              headerMsg: err.header || common.ops,
              rightCTAText: err.btnMsg || common.ok,
            };
            dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
          });
      } catch (err) {
        console.error("Resend OTP ERROR", err);
      } finally {
        commit("updateCustomContinueProgressBar", false);
      }
    },
    cardCheckValidator({ state, commit, dispatch, rootState }) {
      ApiCalls.BIN_DISCOUNT_CARD_VALIDATOR({
        headers: Headers(),
        payload: {
          cartId: get(rootState, "PriceDetail.cartData.cartId", ""),
          cardNumber: state.cardNumber,
        },
      })
        .then((response) => {
          state.binDiscountResponse.success = response;
          if (response?.data?.status == "FAILED") {
            commit("updateCardCheckError", {
              ...state.cardCheckError,
              ...response?.data,
            });
          } else {
            commit("updateCardCheckError", {
              ...state.cardCheckError,
              ...response?.data,
            });
          }
        })
        .catch((error) => {
          state.binDiscountResponse.error = error;
        });
    },
  },
};
